// get the href=#chat link and add event listener onclick to it to onclick="GorgiasChat.open();
const chatLinks = document.querySelectorAll('a[href="#chat"]');
Array.from(chatLinks).forEach(function (chatLink) {
  chatLink.addEventListener('click', function (e) {
    e.preventDefault();
    GorgiasChat.open();
  });
});

const chatCloseButton = document.querySelector('.morobe-close-button');
if (chatCloseButton) {
  chatCloseButton.addEventListener('click', function (e) {
    e.preventDefault();
    GorgiasChat.close();
  });
}

var initGorgiasChatPromise = window.GorgiasChat
  ? window.GorgiasChat.init()
  : new Promise(function (resolve) {
      window.addEventListener('gorgias-widget-loaded', function () {
        resolve();
      });
    });

initGorgiasChatPromise.then(function () {
  GorgiasChat.on('widget:closed', function () {
    document.body.classList.remove('gorgias-chat-open');
  });

  GorgiasChat.on('widget:opened', function () {
    document.body.classList.add('gorgias-chat-open');
  });
});

// get width of sidebar and set css variable --morobe-nav-width to it
// const sidebar = document.querySelector('#morobe-menu');
// if (sidebar) {
//   const sidebarWidth = sidebar.offsetWidth;
//   document.documentElement.style.setProperty('--morobe-nav-width', sidebarWidth + 'px');
// }

class Accordion {
  constructor(el) {
    // Store the <details> element
    this.el = el;
    // Store the <summary> element
    this.summary = el.querySelector('summary');
    // Store the <div class="content"> element
    this.content = el.querySelector('.content');

    // Store the animation object (so we can cancel it if needed)
    this.animation = null;
    // Store if the element is closing
    this.isClosing = false;
    // Store if the element is expanding
    this.isExpanding = false;
    // Detect user clicks on the summary element
    this.summary.addEventListener('click', (e) => this.onClick(e));
  }

  onClick(e) {
    // Stop default behaviour from the browser
    e.preventDefault();

    // check if there is an other details element open
    const details = document.querySelectorAll('main details');
    Array.from(details).forEach((el) => {
      if (el !== this.el && el.open) {
        el.open = false;
      }
    });
    // Add an overflow on the <details> to avoid content overflowing
    this.el.style.overflow = 'hidden';
    // Check if the element is being closed or is already closed
    if (this.isClosing || !this.el.open) {
      this.open();
      // Check if the element is being openned or is already open
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  shrink() {
    // Set the element as "being closed"
    this.isClosing = true;

    // Store the current height of the element
    const startHeight = `${this.el.offsetHeight}px`;
    // Calculate the height of the summary
    const endHeight = `${this.summary.offsetHeight}px`;

    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel();
    }

    // Start a WAAPI animation
    this.animation = this.el.animate(
      {
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight],
      },
      {
        duration: 400,
        easing: 'ease-out',
      }
    );

    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => this.onAnimationFinish(false);
    // If the animation is cancelled, isClosing variable is set to false
    this.animation.oncancel = () => (this.isClosing = false);
  }

  open() {
    // Apply a fixed height on the element
    this.el.style.height = `${this.el.offsetHeight}px`;
    // Force the [open] attribute on the details element
    this.el.open = true;
    // Wait for the next frame to call the expand function
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    // Set the element as "being expanding"
    this.isExpanding = true;
    // Get the current fixed height of the element
    const startHeight = `${this.el.offsetHeight}px`;
    // Calculate the open height of the element (summary height + content height)
    // set a max of 200 for the scrollable content
    const newEndHeight = Math.min(this.summary.offsetHeight + this.content.offsetHeight, 200);
    const endHeight = `${newEndHeight}px`;

    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel();
    }

    // Start a WAAPI animation
    this.animation = this.el.animate(
      {
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight],
      },
      {
        duration: 400,
        easing: 'ease-out',
      }
    );
    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => this.onAnimationFinish(true);
    // If the animation is cancelled, isExpanding variable is set to false
    this.animation.oncancel = () => (this.isExpanding = false);
  }

  onAnimationFinish(open) {
    // Set the open attribute based on the parameter
    this.el.open = open;
    // Clear the stored animation
    this.animation = null;
    // Reset isClosing & isExpanding
    this.isClosing = false;
    this.isExpanding = false;
    // Remove the overflow hidden and the fixed height
    this.el.style.height = this.el.style.overflow = '';
  }
}

document.querySelectorAll('main details').forEach((el) => {
  new Accordion(el);
});
